export default __webpack_public_path__ + "static/media/kr.2b4d800b.svg";